import styled from 'styled-components';

export const Content = styled.div`
  .size-year {
    font-size: 15px;
    color: ${(props) => props.theme.$dark};
  }

  .badge {
    font-size: 12px;
    font-weight: 600;
    padding: 4px 8px;
  }
`;
